// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as DOMPurify$LiveRoom from "../bindings/DOMPurify.bs.js";
import * as SterlingTokens$LiveRoom from "../bindings/SterlingTokens.bs.js";
import * as Tokens from "@sothebys/sterling/tokens";

function RawHtmlContent(props) {
  return React.createElement("p", {
              className: Curry._1(Css.style, {
                    hd: Css.fontFamily({
                          NAME: "custom",
                          VAL: Tokens.FontFamily.mercuryDisplay
                        }),
                    tl: {
                      hd: Css.fontSize(Css.px(16)),
                      tl: {
                        hd: Css.lineHeight(Css.px(26)),
                        tl: {
                          hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryNavy100_nohashtag)),
                          tl: {
                            hd: Css.whiteSpace("preWrap"),
                            tl: {
                              hd: Css.marginTop(Css.px(24)),
                              tl: {
                                hd: Css.marginBottom(Css.px(24)),
                                tl: {
                                  hd: Css.letterSpacing(Css.em(0.014)),
                                  tl: {
                                    hd: Css.overflowY(Css.auto),
                                    tl: {
                                      hd: Css.selector(" a", {
                                            hd: Css.fontWeight({
                                                  NAME: "num",
                                                  VAL: 600
                                                }),
                                            tl: {
                                              hd: Css.textDecoration("none"),
                                              tl: {
                                                hd: Css.visited({
                                                      hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey90_nohashtag)),
                                                      tl: /* [] */0
                                                    }),
                                                tl: {
                                                  hd: Css.hover({
                                                        hd: Css.borderBottom(Css.px(2), Css.solid, Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey90_nohashtag)),
                                                        tl: /* [] */0
                                                      }),
                                                  tl: {
                                                    hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey90_nohashtag)),
                                                    tl: /* [] */0
                                                  }
                                                }
                                              }
                                            }
                                          }),
                                      tl: {
                                        hd: Css.selector(" strong", {
                                              hd: Css.fontWeight({
                                                    NAME: "num",
                                                    VAL: 600
                                                  }),
                                              tl: /* [] */0
                                            }),
                                        tl: {
                                          hd: Css.selector(" em", {
                                                hd: Css.fontStyle(Css.italic),
                                                tl: /* [] */0
                                              }),
                                          tl: {
                                            hd: Css.selector(" u", {
                                                  hd: Css.textDecoration(Css.underline),
                                                  tl: /* [] */0
                                                }),
                                            tl: /* [] */0
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }),
              dangerouslySetInnerHTML: {
                __html: DOMPurify$LiveRoom.sanitize(props.html)
              }
            });
}

var make = RawHtmlContent;

export {
  make ,
}
/* Css Not a pure module */
